export enum GamificationIconType {
    DIAMOND = 'diamond',
    HERO = 'hero',
    HERO_BROKEN = 'hero-broken',
    BADGE = 'badge',
    INVENTORY = 'inventory',
    TOURNAMENT = 'tournament',
    STAR = 'star',
    SHOP = 'shop',
    XP = 'xp',
    INTRO = 'intro',
    CLOCK = 'clock',
    INBOX = 'inbox',
    LEADERBOARD = 'leaderboard',
    LEADERBOARD_START = 'leaderboard-start',
    POINTS = 'points',
    EXCLAMATION = 'exclamation',
    CASHBACK = 'cashback',
}
